import { useCallback } from 'react'
import { HandledDeliveryFee, HandledFrozenFee, PackageSize, Region, StoreDeliveryFeeType } from 'types/storeDeliveryFee'
import { useDispatch } from 'react-redux'
import { FirebaseDocRefType } from 'firebase/index'
import { push } from 'connected-react-router'
import { confirmStoreDeliveryFees } from 'reducks/storeDeliveryFee/operations'

const useConfirmDeliverFees = (
  deliveryFees: HandledDeliveryFee[],
  frozenFees: HandledFrozenFee[],
  PACKAGE_SIZES: PackageSize[],
  storeRef: FirebaseDocRefType
): (() => void) => {
  const dispatch = useDispatch()
  return useCallback(async () => {
    // サイズ毎にデータをまとめ直す
    const storeDeliveryFees: StoreDeliveryFeeType[] = []
    for (let i = 0; i < PACKAGE_SIZES.length; i = (i + 1) | 0) {
      const PACKAGE_SIZE = PACKAGE_SIZES[i]
      const regions: Region[] = deliveryFees.reduce((prev: Region[], deliveryFee) => {
        // 対象サイズを含んでいない場合
        const size = deliveryFee.sizes.find((size) => size.package_size === PACKAGE_SIZE)
        if (!size) return prev
        const region: Region = {
          delivery_fee_amount: size.delivery_fee_amount,
          region_type: deliveryFee.region_type,
          region_name: deliveryFee.region_name,
        }
        return [...prev, region]
      }, [])
      if (regions.length === 0) continue
      const frozen_fee_amount =
        frozenFees.find((frozenFee) => frozenFee.package_size === PACKAGE_SIZE)?.frozen_fee_amount || 0
      const storeDeliveryFee: StoreDeliveryFeeType = {
        frozen_fee_amount,
        package_size: PACKAGE_SIZE,
        regions,
      }
      storeDeliveryFees.push(storeDeliveryFee)
    }
    await dispatch(confirmStoreDeliveryFees(storeDeliveryFees))
    dispatch(push('/delivery/setting/fee/confirm'))
  }, [deliveryFees, frozenFees, PACKAGE_SIZES, storeRef])
}

export default useConfirmDeliverFees
